import { render, staticRenderFns } from "./ProjectsHeader.vue?vue&type=template&id=6494a010"
import script from "./ProjectsHeader.vue?vue&type=script&lang=ts"
export * from "./ProjectsHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports